module.exports = __webpack_public_path__ + "img/fish.479ae0ab.png";